// Gaia Baby theme — shared behaviour: mega menu, accordions, quantity steppers.
// Deliberately a separate file from assets/global.js, which is the real theme's
// own ES module (imported as @NextSkyTheme/global by theme.js and every stock
// component) — this file must never be named global.js or it silently breaks
// every stock section that depends on that module's real exports.
(function () {
  'use strict';

  /* ---------- Mega menu ---------- */
  var shopTrigger = document.getElementById('shopTrigger');
  var megaNav = document.getElementById('megaNav');
  var megaScrim = document.getElementById('megaScrim');

  if (shopTrigger && megaNav && megaScrim) {
    var setMega = function (open) {
      megaNav.classList.toggle('open', open);
      megaScrim.classList.toggle('open', open);
      shopTrigger.setAttribute('aria-expanded', open);
    };
    shopTrigger.addEventListener('click', function () { setMega(!megaNav.classList.contains('open')); });
    megaScrim.addEventListener('click', function () { setMega(false); });
    megaNav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { setMega(false); });
    });
    window.addEventListener('keydown', function (e) { if (e.key === 'Escape') setMega(false); });

    // Close on click anywhere outside the trigger + dropdown — the scrim only
    // covers the area below the header, so a click on another nav link or logo
    // (still inside the header, above the scrim) previously left it open.
    document.addEventListener('click', function (e) {
      if (!megaNav.classList.contains('open')) return;
      if (shopTrigger.contains(e.target) || megaNav.contains(e.target)) return;
      setMega(false);
    });

    // Close when the mouse leaves the trigger + dropdown area entirely, so it
    // also disappears on hover-away, not just on an explicit click.
    var megaHost = shopTrigger.closest('header') || shopTrigger.closest('.site-header');
    if (megaHost) {
      megaHost.addEventListener('mouseleave', function () { setMega(false); });
    }

    // Resizing the window doesn't fire any of the events above, so a menu
    // opened before a resize (e.g. rotating a tablet, or a window drag) stayed
    // open after — stackable with the mobile drawer below since they share no
    // state, producing both the desktop mega nav and the mobile "Menu" panel
    // open at once on a since-widened desktop window.
    window.addEventListener('resize', function () { setMega(false); });
  }

  /* ---------- Mobile drawer menu ---------- */
  var mTrigger = document.getElementById('mobileMenuTrigger');
  var mDrawer = document.getElementById('mobileDrawer');
  var mScrim = document.getElementById('mobileDrawerScrim');
  var mClose = document.getElementById('mobileDrawerClose');

  if (mTrigger && mDrawer && mScrim) {
    var setDrawer = function (open) {
      mDrawer.classList.toggle('open', open);
      mScrim.classList.toggle('open', open);
      mDrawer.setAttribute('aria-hidden', !open);
      mTrigger.setAttribute('aria-expanded', open);
      document.body.classList.toggle('mobile-drawer-open', open);
    };
    mTrigger.addEventListener('click', function () { setDrawer(!mDrawer.classList.contains('open')); });
    mScrim.addEventListener('click', function () { setDrawer(false); });
    if (mClose) mClose.addEventListener('click', function () { setDrawer(false); });
    mDrawer.querySelectorAll('.mdrawer-link, .mdrawer-collection, .mdrawer-catlinks a').forEach(function (a) {
      a.addEventListener('click', function () { setDrawer(false); });
    });
    window.addEventListener('keydown', function (e) { if (e.key === 'Escape') setDrawer(false); });

    mDrawer.querySelectorAll('.mdrawer-toggle').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.mdrawer-item');
        var isOpen = item.classList.contains('open');
        item.classList.toggle('open', !isOpen);
        btn.setAttribute('aria-expanded', !isOpen);
      });
    });

    // Same reasoning as the mega menu's resize listener above: the drawer's
    // trigger button is hidden past the 900px breakpoint, but the drawer's own
    // open state has nothing tying it to that breakpoint, so it survives a
    // resize past it — the trigger disappears but the panel it opened stays.
    window.addEventListener('resize', function () { setDrawer(false); });
  }

  /* ---------- Generic accordion: <div class="acc-item"><button class="acc-head">...<div class="acc-body"> ---------- */
  document.querySelectorAll('.acc-item').forEach(function (item) {
    var head = item.querySelector('.acc-head');
    if (!head) return;
    head.addEventListener('click', function () { item.classList.toggle('open'); });
  });

  /* ---------- Quantity stepper: [data-qty-minus] [data-qty-value] [data-qty-plus] ---------- */
  document.querySelectorAll('[data-qty-root]').forEach(function (root) {
    var minus = root.querySelector('[data-qty-minus]');
    var plus = root.querySelector('[data-qty-plus]');
    var value = root.querySelector('[data-qty-value]');
    var input = root.querySelector('[data-qty-input]');
    if (!minus || !plus || !value) return;
    var set = function (n) {
      n = Math.max(1, n);
      value.textContent = n;
      if (input) input.value = n;
      root.dispatchEvent(new CustomEvent('qtychange', { detail: n, bubbles: true }));
    };
    minus.addEventListener('click', function () { set(parseInt(value.textContent, 10) - 1); });
    plus.addEventListener('click', function () { set(parseInt(value.textContent, 10) + 1); });
  });
})();
